var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7999 8.90023C4.7999 9.56293 4.26261 10.1002 3.59994 10.1002C2.93717 10.1002 2.3999 9.56291 2.3999 8.90023C2.3999 8.23746 2.93719 7.7002 3.59994 7.7002C4.26264 7.7002 4.7999 8.23748 4.7999 8.90023Z",
    fill: "#686D7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7999 8.90023C4.7999 9.56293 4.26261 10.1002 3.59994 10.1002C2.93717 10.1002 2.3999 9.56291 2.3999 8.90023C2.3999 8.23746 2.93719 7.7002 3.59994 7.7002C4.26264 7.7002 4.7999 8.23748 4.7999 8.90023",
    stroke: "#686D7C",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54844 8.90023C9.54844 9.56293 9.01115 10.1002 8.34847 10.1002C7.6857 10.1002 7.14844 9.56291 7.14844 8.90023C7.14844 8.23746 7.68573 7.7002 8.34847 7.7002C9.01117 7.7002 9.54844 8.23748 9.54844 8.90023Z",
    fill: "#686D7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54844 8.90023C9.54844 9.56293 9.01115 10.1002 8.34847 10.1002C7.6857 10.1002 7.14844 9.56291 7.14844 8.90023C7.14844 8.23746 7.68573 7.7002 8.34847 7.7002C9.01117 7.7002 9.54844 8.23748 9.54844 8.90023",
    stroke: "#686D7C",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.297 8.90023C14.297 9.56293 13.7597 10.1002 13.0969 10.1002C12.4342 10.1002 11.897 9.56291 11.897 8.90023C11.897 8.23746 12.4343 7.7002 13.0969 7.7002C13.7597 7.7002 14.297 8.23748 14.297 8.90023Z",
    fill: "#686D7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.297 8.90023C14.297 9.56293 13.7597 10.1002 13.0969 10.1002C12.4342 10.1002 11.897 9.56291 11.897 8.90023C11.897 8.23746 12.4343 7.7002 13.0969 7.7002C13.7597 7.7002 14.297 8.23748 14.297 8.90023",
    stroke: "#686D7C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.cd710fe418849a16288f8fadeb9f9be4.svg";
export { ForwardRef as ReactComponent };